import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';
import { HttpRequestMethods, IDP_APPS } from '../../constants/utils';
import {
  EndpointKeysHeader,
  HEADER_FEATURES
} from '../../constants/utils/app.constants';
import {
  MultiCitySearchCache,
  MultiCitySearchPayload
} from '../../models/search-flights/multi-city-search.interface';
import { CommonConstants } from '../../models/status-tracker/status-tracker.constants';
import {
  ApiBuilder,
  AppConfigService,
  ExtendedCookieHelperUtilsService,
  handleError,
  LoggingService
} from '../utils';

@Injectable({
  providedIn: 'root'
})
export class MultiCityRecentSearchService {
  appConfig = inject(AppConfigService);
  logging = inject(LoggingService);
  http = inject(HttpClient);
  cookieHelper = inject(ExtendedCookieHelperUtilsService);
  errorHandler = handleError.bind(this);

  recentSearchMultiCityObservable$!: Observable<MultiCitySearchCache>;

  getMultiCityRecentSearches$(
    payload: MultiCitySearchPayload
  ): Observable<MultiCitySearchCache> {
    if (this.recentSearchMultiCityObservable$) {
      return this.recentSearchMultiCityObservable$;
    } else {
      this.recentSearchMultiCityObservable$ =
        this.retrieveSlimNavDetailsSearchContent(payload).pipe(shareReplay(1));
      return this.recentSearchMultiCityObservable$;
    }
  }

  private retrieveSlimNavDetailsSearchContent(
    payload: MultiCitySearchPayload
  ): Observable<MultiCitySearchCache> {
    const queryParams = `?CacheKey=${payload.cacheKey}`;
    return new ApiBuilder<MultiCitySearchPayload, MultiCitySearchCache>(
      this.http,
      this.appConfig
    )
      .app(IDP_APPS.BOOK_WIDGET)
      .endpointKey(EndpointKeysHeader['RETRIEVE_SEARCH_MC'])
      .method(HttpRequestMethods['GET'])
      .queryParams(queryParams)
      .errorHandler(this.errorHandler)
      .timeOut(CommonConstants.TIMEOUT)
      .library(HEADER_FEATURES.SEARCH_FLIGHTS)
      .create()
      .pipe(
        catchError((error) => {
          if (error.status === 404) {
            this.cookieHelper.deleteCookie('mc_cache_key');
            this.cookieHelper.setCookies('trip_type', '');
          }
          return of({} as MultiCitySearchCache);
        })
      );
  }
}
